import script from "./worksPage.vue?vue&type=script&setup=true&lang=js"
export * from "./worksPage.vue?vue&type=script&setup=true&lang=js"

import "./worksPage.vue?vue&type=style&index=0&id=0acc3ef2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0acc3ef2"]])

export default __exports__